import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Integrations20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_843)'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.43941 5.50002L8.9394 7L7.46973 8.46967L8.53039 9.53033L10.0001 8.06066L11.9394 10L10.4697 11.4697L11.5304 12.5303L13.0001 11.0607L14.5001 12.5607L18.6769 8.3839C19.165 7.89574 19.165 7.10429 18.6769 6.61613L16.5606 4.49992L19.0303 2.03028L17.9696 0.969619L15.5 3.43926L13.384 1.32324C12.8958 0.835085 12.1043 0.835083 11.6162 1.32324L7.43941 5.50002ZM17.4394 7.50002L14.5001 10.4394L9.56074 5.50002L12.5001 2.56068L17.4394 7.50002Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.99999 17.0607L6.11604 19.1768C6.6042 19.6649 7.39565 19.6649 7.88381 19.1768L12.0606 15L4.99993 7.93934L0.823148 12.1161C0.334993 12.6043 0.334992 13.3957 0.823148 13.8839L2.93933 16.0001L0.469727 18.4697L1.53039 19.5303L3.99999 17.0607ZM2.06058 13L4.99992 10.0607L9.93927 15L6.99992 17.9393L2.06058 13Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_843'>
        <rect width='20' height='20' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Integrations20.displayName = 'Integrations20';
export default Integrations20;
